/**
 * Turns a raw Anthropic HTTP failure into something a user can act on,
 * instead of the provider's raw JSON error body. Shared by AiAssistant.tsx
 * (the live chat) and IntegrationsPage.tsx (the "Test connection" check) so
 * both surfaces describe the same failure the same way.
 */
export function describeAnthropicError(status: number): string {
  if (status === 401 || status === 403) {
    return "Your Anthropic key was rejected (invalid or revoked). Update it under Integrations → AI.";
  }
  if (status === 404) {
    return "That model isn't recognized by Anthropic. Check the Model field under Integrations → AI, or clear it to use the default.";
  }
  return `Anthropic returned an error (status ${status}). Try again in a moment.`;
}
